import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ISortState } from '@/store/interfaces';

export const getters: GetterTree<ISortState, RootState> = {
  getTableSort(state, tableName) {
    return state.table[tableName];
  },
};
